export const theme = {
  colors: {
    primary: '#d6a97a', // Restrained green accent
    secondary: '#e8c29a', // Lighter Blue for hover/subtle accent
    accent: '#d6a97a', // Main accent color
    background: '#161618', // Charcoal page background
    surface: '#27272b', // Darker surface for elements
    card: '#1e1e21', // Primary content surface
    text: '#ededeb', // Headings
    textSecondary: '#bdbdb8', // Body text
    textMuted: '#8f8f8a', // Muted text
    border: '#34343a', // Light border for glass effect
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #38BDF8 0%, #0EA5E9 100%)',
    secondary: 'linear-gradient(135deg, #071427 0%, #1E293B 100%)',
    accent: 'linear-gradient(135deg, #38BDF8 0%, #0EA5E9 100%)',
    background: 'linear-gradient(135deg, #071427 0%, #1E293B 50%, #071427 100%)',
    card: 'linear-gradient(135deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.04) 100%)',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '4rem',
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    full: '9999px',
    card: '16px',
  },
  typography: {
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
  },
};

export type Theme = typeof theme;

export const lightTheme: Theme = {
  ...theme,
  colors: { ...theme.colors, primary: '#8f5a2c', secondary: '#6f4320', accent: '#8f5a2c',
    background: '#f4f2ee', surface: '#eae7e0', card: '#fbfaf7', text: '#1f1f1d',
    textSecondary: '#4a4a46', textMuted: '#6a6a64', border: '#dcd8cf' },
};
